module.exports = __webpack_public_path__ + "static/media/next.b1733f43.svg";